"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Link = _interopRequireDefault(require("../Link/Link"));

var _AnchorLink = _interopRequireDefault(require("../AnchorLink/AnchorLink"));

var _linkHelper2 = _interopRequireDefault(require("../../helpers/linkHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LinkRenderer = function LinkRendererComponent(_ref) {
  var href = _ref.href,
      children = _ref.children,
      className = _ref.className,
      external = _ref.external;

  var _linkHelper = (0, _linkHelper2["default"])(href, external),
      cleanHref = _linkHelper.cleanHref,
      openNewTab = _linkHelper.openNewTab,
      scrollToElement = _linkHelper.scrollToElement;

  var LinkType = scrollToElement ? _AnchorLink["default"] : _Link["default"];
  return /*#__PURE__*/_react["default"].createElement(LinkType, {
    className: className,
    href: cleanHref,
    external: openNewTab
  }, children);
};

LinkRenderer.propTypes = {
  href: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].element)]).isRequired,
  className: _propTypes["default"].string,
  external: _propTypes["default"].bool
};
LinkRenderer.defaultProps = {
  className: '',
  external: false
};
var _default = LinkRenderer;
exports["default"] = _default;